import { Box, useTheme } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

const defaultSize = 24;

const IconRound = React.forwardRef((props, ref) => {
  const { bgcolor, size, ...otherProps } = props;

  const theme = useTheme();

  return (
    <Box
      display="inline-flex"
      justifyContent="center"
      alignItems="center"
      borderRadius="50%"
      width={size ?? defaultSize}
      height={size ?? defaultSize}
      bgcolor={theme.colors[bgcolor] ?? bgcolor}
      {...otherProps}
      ref={ref}
    />
  );
});

IconRound.propTypes = {
  bgcolor: PropTypes.string,
  size: PropTypes.number,
  children: PropTypes.node,
};

IconRound.defaultProps = {
  bgcolor: undefined,
  size: undefined,
  children: undefined,
};

export default IconRound;
